import React from 'react'

import {
  Body3,
  Box,
  Color,
  Display,
  Heading4,
  FlexDirection,
  Space,
  Button,
  ButtonColorVariant,
} from '@gousto-internal/citrus-react'
import { browserHistory } from 'react-router'

import config from 'config/routes'

import { useWelcomeTracking } from '../hooks/useWelcomeTracking'

export const WhatsComingUpNext = () => {
  const { trackGoToMyDashboardClick } = useWelcomeTracking()

  const handleClick = () => {
    trackGoToMyDashboardClick()
    browserHistory.push(config.client.myGousto)
  }

  return (
    <Box display={Display.Flex} flexDirection={FlexDirection.Column} gap={1}>
      <Heading4 size={5}>See what&apos;s coming up next</Heading4>
      <Body3 size={2} color={Color.ColdGrey_800}>
        View and manage all your upcoming orders from your dashboard.
      </Body3>
      <Space size={1} />
      <Button
        colorVariant={ButtonColorVariant.Secondary}
        afterIcon="arrow_right"
        onClick={handleClick}
      >
        Go to my dashboard
      </Button>
    </Box>
  )
}
